import { ActionBtnU as StyledBtn } from "./ActionBtnU.styles";
const ActionBtnU = ({ children, ...props }: any) => (
  <StyledBtn data-testid="submit-btn" {...props}>
    {children}
  </StyledBtn>
);
export default ActionBtnU;
